import type { MaybeRef, Ref } from '@/composition/vue/compositionApi'
import { computed, inject, onBeforeUnmount, onMounted, ref, unref } from '@/composition/vue/compositionApi'
import { CalendarScrollHiddenSymbol } from '@/components/shared/calendar/types'
import { useBreakpoints } from '@/composition/breakpoints'
import type { CalendarTimeSlot } from '@/components/shared/calendar/views/types'
import { createObserver } from '@/utils/observer'

export const calendarScrollEvent = createObserver()

export const useCalendarInnerScroll = () => {
  const forcedHidden = inject<MaybeRef<boolean>>(CalendarScrollHiddenSymbol, false)

  const { isMobile } = useBreakpoints()

  const hideScroll = computed(() => unref(forcedHidden) || isMobile.value)

  return {
    hideScroll,
  }
}

export const useCalendarTimelineAutoscroll = (slotIndex: Ref<number>, slotIndexOffset: number) => {
  const currentTimeRef = ref<HTMLElement>()
  const setTimeRef = (el: any, i: number) => {
    if (!el) return
    if (!('$el' in el)) return
    if (slotIndex.value === -1) return
    if (i !== slotIndex.value + slotIndexOffset) return
    currentTimeRef.value = el.$el
  }

  const scroll = () => currentTimeRef.value?.scrollIntoView(true)
  onMounted(() => {
    calendarScrollEvent.addListener(scroll)
  })
  onBeforeUnmount(() => {
    calendarScrollEvent.removeListener(scroll)
  })

  onMounted(() => {
    const { hideScroll } = useCalendarInnerScroll()
    if (hideScroll.value) return
    scroll()
  })

  const findTimeSlotsIndex = (timeSlots: CalendarTimeSlot[]) => timeSlots.findIndex(({ current }) => current)

  return {
    setTimeRef,
    findTimeSlotsIndex,
  }
}
